import { useEffect } from 'react'
import type { StepProps } from '@/onboardingSurvey/steps/StepProps'
import { useIsMounted } from '@mote/helpers/hooks'
import { useWizard } from '@mote/ui'
import { Step, StepAnswer } from '../components'
import { useOnboarding } from '../context'
import type { Role, RoleQuestionValues } from '../typings'
import { OnboardingRoles } from '../typings'

export const ROLES: RoleQuestionValues = {
  key: 'role',
  trackingKey: 'role (all users)',
  question: 'Welcome to Mote 👋',
  choices: [
    {
      advanceTo: OnboardingRoles.student,
      icon: '🎓',
      text: 'Student',
      value: OnboardingRoles.student
    },
    {
      advanceTo: OnboardingRoles.educator,
      icon: '🍎',
      text: 'Educator',
      value: OnboardingRoles.educator
    },
    {
      advanceTo: OnboardingRoles.personal,
      icon: '🧑',
      text: 'Personal',
      value: OnboardingRoles.personal
    },
    {
      advanceTo: OnboardingRoles.professional,
      icon: '💼',
      text: 'Professional',
      value: OnboardingRoles.professional
    }
  ]
}

export interface RolesProps extends StepProps {
  updateSteps: (role: Role | null) => void
}

export const RolesStep = (props: RolesProps) => {
  const { goToNextStep, isCurrentStep } = useWizard()
  const { state, resetState } = useOnboarding()
  const isActiveStep = isCurrentStep(props.index)
  const isMounted = useIsMounted()

  useEffect(() => {
    if (!state.role) return

    props.updateSteps(state.role)
    goToNextStep()
  }, [state.role])

  useEffect(() => {
    if (!isMounted() || !isActiveStep || (isActiveStep && !state.role)) return

    resetState()
    props.updateSteps(null)
  }, [isActiveStep])

  return (
    <Step
      index={props.index}
      surveyKey={ROLES.key}
      trackingKey={ROLES.trackingKey}
      title={ROLES.question}
      subtitle='Please choose an account type'
    >
      {ROLES.choices.map(roleChoice => (
        <StepAnswer
          key={`${roleChoice.text}-${roleChoice.value}`}
          advanceTo={roleChoice.advanceTo}
          question={ROLES.question}
          surveyKey={ROLES.key}
          text={roleChoice.text}
          icon={roleChoice.icon}
          value={roleChoice.value}
          isSelectable={false}
        />
      ))}
    </Step>
  )
}
